import service from '../../store/httpService.js'
import router from '@/router';
import errorHandling from '../errorHandling';


const mobileVersion = {
    namespaced: true,
    state: {
        getMobileVersionDetails: []
    },
    mutations: {
        GET_MOBILE_DETAILS(state, payload) {
            state.getMobileVersionDetails = payload
        }
    },
    actions: {

        async getMobileVersionInfo({
            state, dispatch,
            commit
        }, payload) {
            await service.getMobileVersionData(payload).then(response => {
                if (response.status == 200) {
                    if (response.data.stat == 'Ok') {
                        for (let idx of response.data.result) {
                            if (idx['deviceType'] == idx['deviceType']) {
                                commit('GET_MOBILE_DETAILS', response.data.result)

                            }
                        }
                        // dispatch('reloadCache')
                    }
                } else {
                    commit('GET_MOBILE_DETAILS', [])
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({

            }))
        },

        async addMobVersion({
            state,
            commit,
            dispatch
        }, payload) {
            await service.addMobileVersionData(payload).then(response => {
                if (response.status == 200) {
                    if (response.data.stat == 'Ok') {
                        commit('SET_SNAKBAR', { msg: response.data.message, show: true, color: 'teal lighten-1', timeout: 2500 }, { root: true })
                        dispatch('getMobileVersionInfo')
                        // dispatch('reloadCache')
                    }
                } else {
                    commit('SET_SNAKBAR', { msg: response.data.message, show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({

            }))
        },

        async deleteMobVersion({
            state,
            commit,
            dispatch,
        }, payload) {
            await service.deleteMobileVersion(payload).then(response => {
                if (response.status == 200) {
                    if (response.data.stat == 'Ok') {
                        commit('SET_SNAKBAR', { msg: 'Deleted Successfully', show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                        dispatch('getMobileVersionInfo')
                        // dispatch('reloadCache')
                    }
                }
                else {
                    commit('SET_SNAKBAR', { msg: response.data.message, show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({

            }))
        },

        async upDateMobVersion({ state, commit, dispatch }, payload) {
            await service.upDateMobileVersion(payload).then(response => {
                if (response.status == 200 && response.data.stat == 'Ok') {
                    commit('SET_SNAKBAR', { msg: 'Updated Successfully', show: true, color: 'teal darken-1', timeout: 2500 }, { root: true })
                    dispatch('getMobileVersionInfo')
                    // dispatch('reloadCache')
                }
                else {
                    commit('SET_SNAKBAR', { msg: response.data.message, show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({

            }))
        },

        async reloadCache({ },) {
            await service.getCacheReload('').then(response => {
                if (response.status == 200) {

                }

            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({}))
        },

        async getholdingsReload({ commit }, payload) {
            await service.getHoldingsCacheReLoad(payload).then(response => {
                if (response.status == 200 && response.data == 'Ok') {
                    commit('SET_SNAKBAR', { msg: 'Cache Reloaded Successfully', show: true, color: 'teal darken-1', timeout: 2500 }, { root: true })

                }
                else {
                    commit('SET_SNAKBAR', { msg: 'Please contact support', show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }

            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({}))
        },

        async allholdingsReload({ commit },) {
            await service.getAllholdingsCacheReLoad('').then(response => {
                if (response.status == 200 && response.data == 'Ok') {

                    commit('SET_SNAKBAR', { msg: 'Cache Reloaded Successfully', show: true, color: 'teal darken-1', timeout: 2500 }, { root: true })

                }
                else {
                    commit('SET_SNAKBAR', { msg: 'Please contact support', show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({}))
        },

        async getPositionReload({ commit }) {
            await service.getPositionCacheReload('').then(response => {
                if (response.status == 200 && response.data == 'Ok') {

                    commit('SET_SNAKBAR', { msg: 'Cache Reloaded Successfully', show: true, color: 'teal darken-1', timeout: 2500 }, { root: true })

                }
                else {
                    commit('SET_SNAKBAR', { msg: 'Please contact support', show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }

            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({}))
        },

        async allPositionReload({ commit }, payload) {
            await service.getAllPositionCacheReload(payload).then(response => {
                if (response.status == 200 && response.data == 'Ok') {
                    commit('SET_SNAKBAR', { msg: 'Cache Reloaded Successfully', show: true, color: 'teal darken-1', timeout: 2500 }, { root: true })
                }
                else {
                    commit('SET_SNAKBAR', { msg: 'Please contact support', show: true, color: 'red lighten-1', timeout: 2500 }, { root: true })
                }
            }, (err) => {
                errorHandling.errLog(err)
            }).finally(({}))
        }
    },

    getters: {
        getMobileVersion: (state) => {
            return state.getMobileVersionDetails
        }
    }

}

export default mobileVersion